import * as Immutable from "immutable";
import BaseMessageRecord from "../BaseMessageRecord";

/**
 * @class BotSwitchMessageRecord
 * @augments BaseMessageRecord
 */
class BotSwitchMessageRecord extends BaseMessageRecord({
  type: "bot_switch",

  /** @memberof BotSwitchMessageRecord# */
  acknowledgeMessage: "",

  /** @memberof BotSwitchMessageRecord# */
  offerSwitchMessage: "",

  /** @memberof BotSwitchMessageRecord# */
  switchButtonLabel: ""
}) {
  /**
   * Validation
   */

  /**
   * @param {BotSwitchMessageRecord} message
   * @returns {Immutable.List.<String>}
   */
  static getInvalidFields(message) {
    const invalidFields = new Set();

    if (!message.offerSwitchMessage) {
      invalidFields.add("offerSwitchMessage");
    }

    // Should include bot_switch variable
    // We will check if the message just includes any variable
    // API will check if the variable has bot_switch name
    if (!/{[0-9a-fA-F]{24}\|}/i.test(message.offerSwitchMessage)) {
      invalidFields.add("offerSwitchMessage");
    }

    if (!message.switchButtonLabel) {
      invalidFields.add("switchButtonLabel");
    }

    if (!message.acknowledgeMessage) {
      invalidFields.add("acknowledgeMessage");
    }

    return Immutable.List(invalidFields);
  }
}

export default BotSwitchMessageRecord;
